var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-accordion-header",
};
const AccordionHeader = React.forwardRef((_a) => {
    var { className, title, disabled, iconOnClose, iconOnOpen, isOpen, onClick, headerComponent } = _a, rest = __rest(_a, ["className", "title", "disabled", "iconOnClose", "iconOnOpen", "isOpen", "onClick", "headerComponent"]);
    const classList = classNames("tecma-accordion-header", { disabled }, className);
    return (_jsx("button", Object.assign({ className: classList, onClick: onClick, type: "button", disabled: disabled }, rest, { children: headerComponent || (_jsxs(_Fragment, { children: [_jsx("h2", { className: "accordion-header-title", children: title }), _jsx(Icon, { iconName: isOpen ? iconOnClose : iconOnOpen, size: "small", className: "icon" })] })) })));
});
AccordionHeader.defaultProps = defaultProps;
export default AccordionHeader;
